import { formatClockTime } from './localTime';
import { useTimeFormat } from './useTimeFormat';

export function CardTime({
  date,
  timeZone,
}: {
  date: Date | string;
  timeZone?: string;
}) {
  const preference = useTimeFormat();
  const instant = new Date(date);
  return (
    <time className="tabular-nums" dateTime={instant.toISOString()}>
      {formatClockTime(instant, preference, timeZone)}
    </time>
  );
}
